import { useLazyGetNotificationsQuery } from 'app/services/notifications';
import {
  showNotifcationsAlertToast,
  showNotificationToast,
} from 'Components/Notifications';
import { ReactNode, useCallback, useEffect } from 'react';
import useNewNotificationCounterState from './useNewNotificationCounterState';

export default function NotificationsToaster({
  children,
}: {
  children: ReactNode;
}) {
  const newNotificationsCount = useNewNotificationCounterState();

  useEffect(() => {
    if (newNotificationsCount && newNotificationsCount > 0) {
      showNotifcationsAlertToast(newNotificationsCount);
    }
  }, [newNotificationsCount]);

  return <>{children}</>;
}
